import { isInvalidString, isInvalidPurchaseOrderNumber, isInvalidVendorName } from "src/validation/stringValidation";
import { FormValidator } from "../formValidator";
import { ValidationError, ValidationErrors } from "src/errors";
import { SendPurchaseOrderFormDataKey } from "src/types";

class SendPurchaseOrderFormValidator extends FormValidator {
  private static validatePurchaseOrderNumber(value: unknown): ValidationError<"purchaseOrderId"> | undefined {
    return isInvalidPurchaseOrderNumber(value)
      ? new ValidationError("Enter a valid purchase order number (e.g., 'PO-2055')", "purchaseOrderId")
      : undefined;
  }

  private static validateVendorName(value: unknown): ValidationError<"vendorName"> | undefined {
    return isInvalidVendorName(value) ? new ValidationError("Enter a valid vendor", "vendorName") : undefined;
  }

  private static validateAdditionalInfo(value: unknown): ValidationError<"additionalInfo"> | undefined {
    return value && isInvalidString(value, 0, 1200)
      ? new ValidationError("Additional information is too long or invalid", "additionalInfo")
      : undefined;
  }

  private static readonly validationStrategies: Record<
    SendPurchaseOrderFormDataKey,
    (inputValue: unknown) => ValidationError<SendPurchaseOrderFormDataKey> | undefined
  > = {
    purchaseOrderId: SendPurchaseOrderFormValidator.validatePurchaseOrderNumber,
    vendorName: SendPurchaseOrderFormValidator.validateVendorName,
    additionalInfo: SendPurchaseOrderFormValidator.validateAdditionalInfo
  };

  static validatePurchaseOrderFormData<T extends SendPurchaseOrderFormDataKey>(
    formData: Partial<Record<T, unknown>>
  ): ValidationErrors<T> {
    return super.validateFormData(formData, SendPurchaseOrderFormValidator.validationStrategies) as ValidationErrors<T>;
  }
}

export { SendPurchaseOrderFormValidator };
